import { useState } from "react";
import DeeperLookIcon_Trans from "../../../assets/UI/DeeperLookIcon_Trans.png";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";
import "../DeeperLook.css"; 


export default function RelationshipsDLook() {

const categories = {

    Relationships_DL_Overview: {
        title: "Relationships in Korean: Overview",
        content: [
            { type: "subheader", content: "Introduction" },
            { 
            type: "paragraph", 
            content: "Relationships shape how we connect with people every day — from family and friends to classmates and coworkers. In Korean, there are specific words for each kind of connection, reflecting closeness, respect, and social context."
            },
            { 
            type: "paragraph", 
            content: "In this deck, you’ll learn basic relationship vocabulary that helps you talk about the people in your life. Each section introduces a different type of relationship, giving you the words you need to describe them naturally in Korean."
            },
            { 
            type: "paragraph", 
            content: "💡 Tip: Pay attention to the formality of each word — some are polite and formal, while others are used only with close friends."
            }
    ]},
    
    Relationships_DL_TypesOfRelationships: {
        title: "Types of Relationships",
        content: [
            { type: "subheader", content: "Introduction" },
            { 
            type: "paragraph", 
            content: "These are foundational words that describe how people are connected."
            },
            { 
            type: "table", 
            rows: [
                ["English", "Korean (Hangul)", "Notes"],
                ["Relationship", "관계 (gwan-gye)", "General term for a relationship or connection"],
                ["Family", "가족 (ga-jok)", "Family or household"],
                ["Friend", "친구 (chin-gu)", "Friend"],
                ["Acquaintance", "지인 (ji-in)", "Someone you know casually"],
                ["Classmate", "반친구 (ban-chin-gu)", "Friend or peer from the same class"],
                ["Colleague", "동료 (dong-ryo)", "Coworker or colleague"],
                ["Neighbor", "이웃 (i-ut)", "Someone who lives nearby"],
                ["Partner", "파트너 (pa-teu-neo)", "General term for a partner (work or personal)"]
            ]
            },
            { 
            type: "paragraph", 
            content: "💡 Tip: Many of these words change slightly when combined with other terms (like 'close friend' or 'school friend'), which you’ll learn in later decks."
            }
        ]
    },

    Relationships_DL_RomanticRelationships: {
        title: "Romantic Relationships",
        content: [
            { type: "subheader", content: "Introduction" },
            { 
            type: "paragraph", 
            content: "These are simple words to talk about romantic connections in Korean."
            },
            { 
            type: "table", 
            rows: [
                ["English", "Korean (Hangul)", "Notes"],
                ["Partner", "파트너 (pa-teu-neo)", "General term for a partner"],
                ["Love", "사랑 (sarang)", "Love or affection"],
                ["Crush", "짝사랑 (jjak-sarang)", "One-sided love"],
                ["Spouse", "배우자 (bae-u-ja)", "Formal term for husband or wife"]
            ]
            },
            { 
            type: "paragraph", 
            content: "💡 Tip: 남자친구 / 여자친구 are the most commonly used words in casual conversation to refer to a partner."
            }
        ]
    },

    Relationships_DL_Friendships: {
    title: "Friendships and Social Bonds",
    content: [
        { type: "subheader", content: "Introduction" },
        { 
        type: "paragraph", 
        content: "These are words to describe friends, peers, and social connections in Korean."
        },
        { 
        type: "table", 
        rows: [
            ["English", "Korean (Hangul)", "Notes"],
            ["Friend", "친구 (chingu)", "General term for a friend"],
            ["Close Friend", "친한 친구 (chinhan chingu)", "Literally 'close friend'"],
            ["Best Friend", "베스트프렌드 (beseuteu peuren-deu)", "Loanword from English, informal"],
            ["Peer / Same Age Friend", "동갑 친구 (dong-gap chingu)", "Friend of the same age"],
            ["Senior", "선배 (seon-bae)", "Someone older or higher in rank (school/work)"],
            ["Junior", "후배 (hu-bae)", "Someone younger or lower in rank"],
            ["Companion", "동반자 (dong-ban-ja)", "Someone you share experiences with"]
        ]
        }
    ]
},

Relationships_DL_Connections: {
  title: "Talking About Relationships",
  content: [
    { type: "subheader", content: "Introduction" },
    { 
      type: "paragraph", 
      content: "These words describe different types of connections and how people relate to each other in Korean."
    },
    { 
      type: "table", 
      rows: [
        ["English", "Korean (Hangul)", "Notes"],
        ["Family member", "가족 구성원 (ga-jok gu-seong-won)", "Any member of a family"],
        ["Friend circle", "친구들 (chin-gu-deul)", "Group of friends"],
        ["Romantic partner", "연인 (yeon-in)", "General term for boyfriend/girlfriend or lover"],
        ["Close relationship", "친밀한 관계 (chin-mil-han gwan-gye)", "Close/intimate relationship"],
        ["Long-term friendship", "오랜 친구 (o-raen chin-gu)", "Friendship lasting a long time"]
      ]
    }
  ]
}






};

 
 
   //Make overveiw the default catgory selected when page loads
   const [selectedCategory, setSelectedCategory] = useState("Relationships_DL_Overview");
 
 
   return (
     <div>
       
       <HeaderNavNTM GoBack_to="/RelationshipsNav"/>
 
       <div className="blue-header-dlook">
         <img
           className="DeeperLookImage-dlook"
           src={DeeperLookIcon_Trans}
           alt="Deeper Look"
         />
       </div>

       <div className="panel-container-dlook">

         <div className="side-panel-dlook">
           {Object.keys(categories).map(key => (

             <p
               key={key}

               className={key === selectedCategory 
                 ? "category-active" 
                 : "category-inactive"}

               onClick={() => setSelectedCategory(key)}
             >              
               {categories[key].title}
             </p>
           ))}
         </div>
 
         {/* Text panel */}
     <div className="text-panel-dlook">
        {(categories[selectedCategory]?.content ?? []).map((item, index) => {

 
            switch (item.type) {

  
             case "subheader":
                 return <h3 key={index} className="subheader-dlook">{item.content}</h3>;
 
             case "paragraph":
                 return <p key={index}>{item.content}</p>;
 
             case "list":
                 return (
                 <ul key={index} className="list-dlook">
                     {item.items.map((bullet, i) => (
                     <li key={i}>{bullet}</li>
                     ))}
                 </ul>
                 );
 
             case "table":
                 return (
                 <table key={index} className="table-dlook">
                     <tbody>
                     {item.rows.map((row, r) => (
                         <tr key={r}>
                         {row.map((cell, c) => (
                             <td key={c}>{cell}</td>
                         ))}
                         </tr>
                     ))}
                     </tbody>
                 </table>
                 );
 
             default:
                 return null;

             }
             })}
         </div>
 
       </div>
      
       {/* End Body */}
     
     
     
     </div>
   );{/* End return */}
 } 
 
